import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardPackagePurchaseHistoryUX = (props: any) => {
    return(
      <div
        id="CardPackagePurchaseHistoryUX-div-0"
        style={{width: "100%"}}>
        <div
          id="CardPackagePurchaseHistoryUX-div-1"
          style={{display: props.hideTitle?"none":"flex", alignItems: "center", justifyContent: "space-between", padding: "15px 10px", backgroundColor: "#F2F2F2"}}>
          
          <div
            id="CardPackagePurchaseHistoryUX-div-3"
            style={{fontSize: "1.2rem", fontWeight: "bold", color: "#0072BC"}}>
            {props.languageUX === "en" ? "Package purchase history" : "ประวัติการซื้อแพ็กเกจ"}
          </div>
        </div>
        <div
          className="ui divider"
          id="CardPackagePurchaseHistoryUX-div-2"
          style={{marginTop: 0, border: "none"}}>
          
        </div>
        <div
          id="CardPackagePurchaseHistoryUX-div-4"
          style={{padding: "0 15px"}}>
          
          <div
            className="ui form"
            id="CardPackagePurchaseHistoryUX-div-5">
            
            <FormGroup
              id="CardPackagePurchaseHistoryUX-FormGroup-6"
              inline={true}>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-81"
                inline={true}
                style={{display: props.showPackageNameFilter?"":"none"}}
                width={2}>
                <Input
                  fluid={true}
                  icon="search"
                  id="CardPackagePurchaseHistoryUX-Input-82"
                  name="programName"
                  onChange={props.onChangeValue}
                  placeholder="ค้นหาชื่อบริการ"
                  value={props.filterPurchaseHistory?.programName || ""}>
                </Input>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-41"
                inline={true}
                style={{display: props.hideProgramNameFilter?"none":""}}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-53"
                  style={{width: "110px"}}>
                  {props.languageUX === "en" ? "Package name/code" : "ชื่อ/รหัสแพ็กเกจ"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-42"
                inline={true}
                style={{display: props.hideProgramNameFilter?"none":""}}
                width={4}>
                <div
                  id="CardPackagePurchaseHistoryUX-div-59"
                  style={{width: "100%"}}>
                  {props.SearchBoxPackageName}
                </div>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-77"
                inline={true}
                style={{display: props.showPackageNameFilter?"":"none", marginLeft: "5px" }}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-79"
                  style={{ minWidth: "max-content" }}>
                  {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-78"
                inline={true}
                style={{display: props.showPackageNameFilter?"":"none"}}
                width={2}>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardPackagePurchaseHistoryUX-Dropdown-80"
                  name="serviceType"
                  onChange={props.onChangeValue}
                  options={props.packageServiceTypeOptions || []}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPurchaseHistory?.serviceType || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-45"
                inline={true}
                style={{ marginLeft: "5px" }}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-55"
                  style={{ minWidth: "max-content" }}>
                  {props.languageUX === "en" ? "Usage" : "การใช้งาน"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-46"
                inline={true}
                width={2}>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardPackagePurchaseHistoryUX-Dropdown-61"
                  name="usage"
                  onChange={props.onChangeValue}
                  options={props.usageOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPurchaseHistory?.usage}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-83"
                inline={true}
                style={{display: props.hideDivisionFilter?"none":""}}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-85"
                  style={{width: "105px", textAlign: "right"}}>
                  {props.languageUX === "en" ? "Order date" : "วันที่สั่งซื้อ"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-84"
                inline={true}
                style={{display: props.hideDivisionFilter?"none":""}}
                width={4}>
                <DateTextBox
                  id="CardPackagePurchaseHistoryUX-DateTextBox-86"
                  onChange={props.onChangeCreatedDate}
                  style={{width: "100%"}}
                  value={props.filterPurchaseHistory?.createdDate || ""}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-45"
                inline={true}
                style={{ marginLeft: "5px" }}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-55"
                  style={{ minWidth: "max-content" }}>
                  {props.languageUX === "en" ? "Payment status" : "การชำระเงิน"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-46"
                inline={true}
                width={2}>
                <div
                  id="CardPackagePurchaseHistoryUX-div-93"
                  style={{ width: "100%" }}>
                  {props.customStatus}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPackagePurchaseHistoryUX-FormGroup-19"
              inline={true}>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-47"
                inline={true}
                style={{display: props.hideDivisionFilter?"none":""}}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-56"
                  style={{width: "110px"}}>
                  {props.languageUX === "en" ? "Service department" : "แผนกที่ให้บริการ"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-48"
                inline={true}
                style={{display: props.hideDivisionFilter?"none":""}}
                width={4}>
                <Dropdown
                  clearable={true}
                  disabled={props.selectable}
                  fluid={true}
                  id="CardPackagePurchaseHistoryUX-Dropdown-62"
                  name="division"
                  onChange={props.onChangeValue}
                  options={props.serviceDivisionOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%",  ...(props.selectable && {background: "#EAEAEA", opacity:0.75, border: "none"})}}
                  value={props.filterPurchaseHistory?.division || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-49"
                inline={true}
                style={{display: props.showPackageNameFilter?"none":""}}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-57"
                  style={{width: "95px", textAlign: "right"}}>
                  {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-50"
                inline={true}
                style={{display: props.showPackageNameFilter?"none":""}}
                width={4}>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardPackagePurchaseHistoryUX-Dropdown-63"
                  name="serviceType"
                  onChange={props.onChangeValue}
                  options={props.packageServiceTypeOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPurchaseHistory?.serviceType || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-51"
                inline={true}
                style={{display: props.hideDivisionFilter?"none":""}}>
                <label
                  id="CardPackagePurchaseHistoryUX-label-58"
                  style={{width: "105px", textAlign: "right"}}>
                  {props.languageUX === "en" ? "Package Type" : "ประเภทแพ็กเกจ"}
                </label>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-52"
                inline={true}
                style={{display: props.hideDivisionFilter?"none":""}}
                width={4}>
                <Dropdown
                  className="inline-label"
                  clearable={true}
                  fluid={true}
                  id="CardPackagePurchaseHistoryUX-Dropdown-72"
                  name="packageType"
                  onChange={props.onChangeValue}
                  options={props.packageTypeOptions ||  []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPurchaseHistory?.packageType || ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPackagePurchaseHistoryUX-FormGroup-65"
              inline={true}>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-66"
                inline={true}
                style={{flex: 1}}>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-67"
                inline={true}>
                <div
                  id="CardPackagePurchaseHistoryUX-div-71">
                  {props.ButtonSearch}
                </div>
              </FormField>
              <FormField
                id="CardPackagePurchaseHistoryUX-FormField-68"
                inline={true}>
                <Button
                  color="yellow"
                  id="CardPackagePurchaseHistoryUX-Button-70"
                  onClick={props.onClear}>
                  {props.languageUX === "en" ? "clear" : "เคลียร์"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form"
            id="CardPackagePurchaseHistoryUX-div-39"
            style={{marginTop: "1rem"}}>
            
            <Table
              className="--rt-tbody-overflow-y-hidden"
              columns={props.purchaseHistoryColumns}
              data={props.purchaseHistoryItems || []}
              getTrProps={props.getTrProps}
              headers={props.purchaseHistoryHeaders}
              id="CardPackagePurchaseHistoryUX-Table-40"
              keys={props.purchaseHistoryKeys}
              minRows={3}
              showPagination={false}
              style={{maxHeight: "300px", ...(props.showPackageNameFilter && {maxHeight: "430px"})}}
              widths={props.purchaseHistoryWidths}>
            </Table>
          </div>
        </div>
      </div>
    )
}


export default CardPackagePurchaseHistoryUX

export const screenPropsDefault = {"language":"EN","price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Thu Sep 10 2026 15:21:43 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideTitle?\"none\":\"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"15px 10px\", backgroundColor: \"#F2F2F2\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: 0, border: \"none\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการซื้อแพ็กเกจ",
          "valueEN": "Package purchase history"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\", color: \"#0072BC\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 15px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormGroup-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 40,
      "name": "Table",
      "parent": 39,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.purchaseHistoryColumns"
        },
        "data": {
          "type": "code",
          "value": "props.purchaseHistoryItems || []"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "code",
          "value": "props.purchaseHistoryHeaders"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Table-40"
        },
        "keys": {
          "type": "code",
          "value": "props.purchaseHistoryKeys"
        },
        "minRows": {
          "type": "code",
          "value": "3"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{maxHeight: \"300px\", ...(props.showPackageNameFilter && {maxHeight: \"430px\"})}"
        },
        "widths": {
          "type": "code",
          "value": "props.purchaseHistoryWidths"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideProgramNameFilter?\"none\":\"\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideProgramNameFilter?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"5px\" }"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideDivisionFilter?\"none\":\"\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideDivisionFilter?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageNameFilter?\"none\":\"\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-50"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageNameFilter?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideDivisionFilter?\"none\":\"\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideDivisionFilter?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ/รหัสแพ็กเกจ",
          "valueEN": "Package name/code"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{width: \"110px\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "การใช้งาน",
          "valueEN": "Usage"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-55"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกที่ให้บริการ",
          "valueEN": "Service department"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{width: \"110px\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{width: \"95px\", textAlign: \"right\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "label",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทแพ็กเกจ",
          "valueEN": "Package Type"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-58"
        },
        "style": {
          "type": "code",
          "value": "{width: \"105px\", textAlign: \"right\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxPackageName"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Dropdown",
      "parent": 46,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Dropdown-61"
        },
        "name": {
          "type": "value",
          "value": "usage"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.usageOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPurchaseHistory?.usage"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Dropdown",
      "parent": 48,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.selectable"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Dropdown-62"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.serviceDivisionOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",  ...(props.selectable && {background: \"#EAEAEA\", opacity:0.75, border: \"none\"})}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPurchaseHistory?.division || \"\""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Dropdown",
      "parent": 50,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Dropdown-63"
        },
        "name": {
          "type": "value",
          "value": "serviceType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageServiceTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPurchaseHistory?.serviceType || \"\""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormGroup-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Button",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Button-70"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Dropdown",
      "parent": 52,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Dropdown-72"
        },
        "name": {
          "type": "value",
          "value": "packageType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageTypeOptions ||  []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPurchaseHistory?.packageType || \"\""
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-77"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageNameFilter?\"\":\"none\", marginLeft: \"5px\" }"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-78"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageNameFilter?\"\":\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-79"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "Dropdown",
      "parent": 78,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Dropdown-80"
        },
        "name": {
          "type": "value",
          "value": "serviceType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageServiceTypeOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPurchaseHistory?.serviceType || \"\""
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-81"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageNameFilter?\"\":\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Input",
      "parent": 81,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-Input-82"
        },
        "name": {
          "type": "value",
          "value": "programName"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาชื่อบริการ"
        },
        "value": {
          "type": "code",
          "value": "props.filterPurchaseHistory?.programName || \"\""
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideDivisionFilter?\"none\":\"\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideDivisionFilter?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สั่งซื้อ",
          "valueEN": "Order date"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-85"
        },
        "style": {
          "type": "code",
          "value": "{width: \"105px\", textAlign: \"right\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 86,
      "name": "DateTextBox",
      "parent": 84,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-DateTextBox-86"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCreatedDate"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPurchaseHistory?.createdDate || \"\""
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"5px\" }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "label",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "การชำระเงิน",
          "valueEN": "Payment status"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-label-55"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.customStatus"
        },
        "id": {
          "type": "value",
          "value": "CardPackagePurchaseHistoryUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 93,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardPackagePurchaseHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN",
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
